import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import { getApiPublic, publicGetKnowledgeList } from '@/graphql/queries';
import { updateApiPublic } from '@/graphql/mutations';

export const getPublicAPI = async (APIClient, params) => {
    try {
        let res = await API.graphql({
            query: getApiPublic,
            variables: {
                params: JSON.stringify(params)
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        return res.data.getApiPublic;
    } catch (err) {
        console.log('getPublicAPI err', err);
        return {};
    }
};

export const updatePublicAPI = async (APIClient, params) => {
    try {
        let res = await API.graphql({
            query: updateApiPublic,
            variables: {
                updateApiPublicRequestDto: JSON.stringify({
                    ...params
                })
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        return res.data.updateApiPublic;
    } catch (err) {
        console.log('updatePublicAPI err', err);
        return {};
    }
};

export const publicGetKnowledgeListAPI = async (APIClient, params) => {
    try {
        let res = await API.graphql({
            query: publicGetKnowledgeList,
            variables: {
                params: JSON.stringify(params)
            },
            authMode: Constant.AUTH_MODE_API_KEY,
        });
        const response = res?.data?.publicGetKnowledgeList;
        return response;
    } catch (err) {
        console.log('publicGetKnowledgeListAPI err', err);
        return {};
    }
};